import * as Sentry from '@sentry/browser'

export function flushSentry(timeout: number = 2000) {
  const client = Sentry.getCurrentHub().getClient()
  if (client) {
    return Promise.resolve(client.close(timeout))
  }
  return Promise.resolve(false)
}
